import { FC, ReactNode } from 'react'
import { useRevalidator } from 'react-router-dom'
import LoadedPageHeader from './LoadedPageHeader'
import PageLoadingSupport from './PageLoadingSupport'
import FullPageLoader from './FullPageLoader'
import { Stack } from '@mui/material'

type LoadedPageContentProps = {
  children: ReactNode
  title?: string
  displayLeftTitle?: boolean
  displayDateFilter?: boolean
  customBottomLeftComponent?: string
}

const LoadedPageContent: FC<LoadedPageContentProps> = ({
  children,
  title,
  displayLeftTitle,
  displayDateFilter,
  customBottomLeftComponent,
}) => {
  const revalidator = useRevalidator()

  return (
    //Spacing property doesn't work in stack because of the render order
    //so we need to use the sx property
    <Stack
      sx={{
        marginBottom:
          revalidator.state === 'loading' ? '0rem' : title ? '1.6rem' : '0rem',
      }}
    >
      {title && (
        <LoadedPageHeader
          title={title}
          displayLeftTitle={displayLeftTitle}
          displayDateFilter={displayDateFilter}
          customBottomLeftComponent={customBottomLeftComponent}
        />
      )}
      <PageLoadingSupport isNestedLoader={true}>
        {revalidator.state === 'loading' ? <FullPageLoader /> : children}
      </PageLoadingSupport>
    </Stack>
  )
}

export default LoadedPageContent
